import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";

const styles = {
  cell: {
    border: "1px solid #000",
    padding: "4px",
    textAlign: "center",
    verticalAlign: "middle",
  },
};

function RADPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>Results and Discussion</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <h5>
              Modeling Landscape Dynamics and spatial configuration of Tumkur
            </h5>
            <p>
              LC of Tumkur district is assessed by computing NDVI over a
              temporal scale depicts the area under vegetation and
              non-vegetation (Figure 3). The vegetation cover has lost from
              98.62% (1989) to 95.82% (2019) with an increase in area under
              non-vegetation (1.38% to 4.18%).
            </p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/tl3.png" alt="" />{" "}
            </p>

            <p style={{ textAlign: "center" }}>
              Figure 3. Land cover dynamics in &nbsp;Tumkur
            </p>
            <p>
              LU analysis highlights the intense anthropogenic-induced changes
              post 1999 (Figure 4). The region has lost agriculture and
              horticulture areas along the national highways (NH), the
              peri-urban area of Tumkur city, and NH-48. There is a significant
              increase in built-up cover (0.02% to 2.11%), and marginal increase
              in horticulture (0.94% to 1.02%) and forest plantation (0.13 to
              0.2%). Encouragement towards the more profitable horticultural
              products and the water availability due to the higher number of
              borewells aided in the increase of horticultural area along
              highways. But, post-2000, horticulture areas have been converted
              into built-up areas due to the expansion of highways. Scrub land
              is decreased from 21.59% (1989) to 7.29% (2019) (Table 2) with the
              transition of scrubland to horticulture land. Dry deciduous
              forests decreased from 10.43% (1989) to 4.34% (2019). Solar
              installation in the Pavagada taluk has resulted in the conversion
              of barren agriculture areas but aided in meeting electricity
              demand through renewable sources. Rampant mining also contributed
              to the forest cover loss and higher instances of human-animal
              conflicts. The OA and the kappa statistics is presented in Table
              3. Field investigation and Google earth data sets were used to
              analyze accuracies, ranging from 87% to 96%.
              <br />
              <br />
            </p>
            <p>Table 2. LU dynamics in Tumkur from 1989 to 2019</p>
            <table width="100%">
              <tbody>
                <tr>
                  <td style={styles.cell} width="19%">
                    <p>
                      <strong>Year</strong>
                    </p>
                  </td>
                  <td style={styles.cell} colspan="2" width="20%">
                    <p>
                      <strong>1989</strong>
                    </p>
                  </td>
                  <td style={styles.cell} colspan="2" width="21%">
                    <p>
                      <strong>1999</strong>
                    </p>
                  </td>
                  <td style={styles.cell} colspan="2" width="20%">
                    <p>
                      <strong>2009</strong>
                    </p>
                  </td>
                  <td style={styles.cell} colspan="2" width="19%">
                    <p>
                      <strong>2019</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="19%">
                    <p>
                      <strong>Category</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>
                      <strong>Sq km</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>
                      <strong>%</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="12%">
                    <p>
                      <strong>Sq km</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>
                      <strong>%</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>
                      <strong>Sq km</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>
                      <strong>%</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>
                      <strong>Sq km</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>
                      <strong>%</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="19%">
                    <p>Agriculture</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>5,196.80</p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>49.04</p>
                  </td>
                  <td style={styles.cell} width="12%">
                    <p>4817.3</p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>45.46</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>4932.74</p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>46.55</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>5164.92</p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>48.74</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="19%">
                    <p>Built Up</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>1.78</p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>0.02</p>
                  </td>
                  <td style={styles.cell} width="12%">
                    <p>59.3</p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>0.56</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>138.88</p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>1.31</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>224</p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>2.11</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="19%">
                    <p>Dry Deciduous</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>1104.8</p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>10.43</p>
                  </td>
                  <td style={styles.cell} width="12%">
                    <p>869.15</p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>8.20</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>739.7</p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>6.98</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>460.08</p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>4.34</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="19%">
                    <p>Horticulture</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>99.73</p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>0.94</p>
                  </td>
                  <td style={styles.cell} width="12%">
                    <p>852.38</p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>8.04</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>359.4</p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>3.39</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>108.11</p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>1.02</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="19%">
                    <p>Hillocks</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>1,635.55</p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>15.43</p>
                  </td>
                  <td style={styles.cell} width="12%">
                    <p>2,097.25</p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>19.79</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>2856.32</p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>26.95</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>3492.24</p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>32.95</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="19%">
                    <p>Others</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>107.63</p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>1.02</p>
                  </td>
                  <td style={styles.cell} width="12%">
                    <p>183.37</p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>1.73</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>109.57</p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>1.03</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>122.63</p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>1.16</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="19%">
                    <p>Scrubland</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>2288.35</p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>21.59</p>
                  </td>
                  <td style={styles.cell} width="12%">
                    <p>1,541.58</p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>14.55</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>1295.59</p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>12.23</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>772.7</p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>7.29</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="19%">
                    <p>Water</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>148.25</p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>1.40</p>
                  </td>
                  <td style={styles.cell} width="12%">
                    <p>166.12</p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>1.57</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>150.71</p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>1.42</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>192.6</p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>1.82</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="19%">
                    <p>Forest Plantation</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>14.13</p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>0.13</p>
                  </td>
                  <td style={styles.cell} width="12%">
                    <p>10.57</p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>0.10</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>14.11</p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>0.13</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>21.29</p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>0.20</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="19%">
                    <p>Solar Panels</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>--</p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>--</p>
                  </td>
                  <td style={styles.cell} width="12%">
                    <p>--</p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>--</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>--</p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>--</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>38.45</p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>0.36</p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>Table 3 Accuracy assessment of temporal data</p>
            <table width="100%">
              <tbody>
                <tr>
                  <td style={styles.cell} width="15%">
                    <p>
                      <strong>Year</strong>
                    </p>
                  </td>
                  <td style={styles.cell} colspan="2" width="19%">
                    <p>
                      <strong>1989</strong>
                    </p>
                  </td>
                  <td style={styles.cell} colspan="2" width="21%">
                    <p>
                      <strong>1999</strong>
                    </p>
                  </td>
                  <td style={styles.cell} colspan="2" width="21%">
                    <p>
                      <strong>2009</strong>
                    </p>
                  </td>
                  <td style={styles.cell} colspan="2" width="20%">
                    <p>
                      <strong>2019</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="15%">
                    <p>
                      <strong>Category</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>
                      <strong>PA</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>
                      <strong>UA</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>
                      <strong>PA</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="10%">
                    <p>
                      <strong>UA</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>
                      <strong>PA</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="10%">
                    <p>
                      <strong>UA</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>
                      <strong>PA</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>
                      <strong>UA</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="15%">
                    <p>Agriculture</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>100.0</p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>93.7</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>99.43</p>
                  </td>
                  <td style={styles.cell} width="10%">
                    <p>93.60</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>100.0</p>
                  </td>
                  <td style={styles.cell} width="10%">
                    <p>79.3</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>96.93</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>97.14</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="15%">
                    <p>Built Up</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>100.0</p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>67.7</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>6.19</p>
                  </td>
                  <td style={styles.cell} width="10%">
                    <p>98.90</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>100.0</p>
                  </td>
                  <td style={styles.cell} width="10%">
                    <p>54.9</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>31.34</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>89.66</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="15%">
                    <p>Dry Deciduous</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>100.0</p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>62.1</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>88.16</p>
                  </td>
                  <td style={styles.cell} width="10%">
                    <p>55.57</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>78.7</p>
                  </td>
                  <td style={styles.cell} width="10%">
                    <p>93.9</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>92.84</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>100.00</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="15%">
                    <p>Hillocks</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>100.0</p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>93.0</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>96.02</p>
                  </td>
                  <td style={styles.cell} width="10%">
                    <p>83.70</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>94.5</p>
                  </td>
                  <td style={styles.cell} width="10%">
                    <p>67.9</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>95.86</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>61.10</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="15%">
                    <p>Horticulture</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>100.0</p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>74.0</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>93.83</p>
                  </td>
                  <td style={styles.cell} width="10%">
                    <p>91.93</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>99.0</p>
                  </td>
                  <td style={styles.cell} width="10%">
                    <p>69.9</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>95.81</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>98.57</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="15%">
                    <p>Scrubland</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>100.0</p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>74.4</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>99.65</p>
                  </td>
                  <td style={styles.cell} width="10%">
                    <p>99.47</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>100.0</p>
                  </td>
                  <td style={styles.cell} width="10%">
                    <p>85.9</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>90.25</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>54.62</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="15%">
                    <p>Water</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>77.7</p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>100.0</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>94.81</p>
                  </td>
                  <td style={styles.cell} width="10%">
                    <p>87.53</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>99.4</p>
                  </td>
                  <td style={styles.cell} width="10%">
                    <p>79.1</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>99.44</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>97.20</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="15%">
                    <p>Others</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>100.0</p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>100.0</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>96.91</p>
                  </td>
                  <td style={styles.cell} width="10%">
                    <p>46.33</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>55.6</p>
                  </td>
                  <td style={styles.cell} width="10%">
                    <p>97.4</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>60.87</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>87.51</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="15%">
                    <p>OA</p>
                  </td>
                  <td style={styles.cell} colspan="2" width="19%">
                    <p>90.19</p>
                  </td>
                  <td style={styles.cell} colspan="2" width="21%">
                    <p>89.00</p>
                  </td>
                  <td style={styles.cell} colspan="2" width="21%">
                    <p>87.0</p>
                  </td>
                  <td style={styles.cell} colspan="2" width="20%">
                    <p>95.49</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="15%">
                    <p>Kappa</p>
                  </td>
                  <td style={styles.cell} colspan="2" width="19%">
                    <p>0.85</p>
                  </td>
                  <td style={styles.cell} colspan="2" width="21%">
                    <p>0.84</p>
                  </td>
                  <td style={styles.cell} colspan="2" width="21%">
                    <p>0.82</p>
                  </td>
                  <td style={styles.cell} colspan="2" width="20%">
                    <p>0.93</p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/tl4.png" alt="" />{" "}
            </p>

            <p style={{ textAlign: "center" }}>
              Figure 4. Spatio temporal LU change in Tumkur district
            </p>
            <p>
              LU transition from 1989 to 2019 indicates a greater loss in the
              dry deciduous class from 1104.80 sq km to 460.08 sq km (Table 4).
              The increased commercial value of horticulture crops has resulted
              in large-scale agricultural land conversion into horticulture at
              Tiptur taluk due to canal irrigation from Vedavathi river. The
              industrialization, highway expansion, and establishment of an
              industrial estate at Dabaspet (outskirts of Bangalore city) have
              increased built-up cover. Rapid industrialization from post-2010
              resulted in new satellite towns along the highways. The
              large-scale agriculture and horticulture lands have been cleared
              and kept barren for conversion into buildings or industries, which
              has become a key policy and governance challenges in the district.
            </p>
            <p>Table 4. The transition of LU from 1989 to 2019</p>
            <table width="100%">
              <tbody>
                <tr>
                  <td style={styles.cell} rowspan="12" width="4%">
                    <p>Land use of 1989</p>
                  </td>
                  <td style={styles.cell} colspan="11" width="95%">
                    <p>Land use of 2019</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="12%">
                    <p>Category</p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>Agriculture</p>
                  </td>
                  <td style={styles.cell} width="5%">
                    <p>Built Up</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>Dry Deciduous</p>
                  </td>
                  <td style={styles.cell} width="10%">
                    <p>Horticulture</p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>Hillocks</p>
                  </td>
                  <td style={styles.cell} width="7%">
                    <p>Others</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>Scrubland</p>
                  </td>
                  <td style={styles.cell} width="6%">
                    <p>Water</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>Forest Plantation</p>
                  </td>
                  <td style={styles.cell} width="7%">
                    <p>
                      <strong>1989</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="12%">
                    <p>Agriculture</p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>3625.57</p>
                  </td>
                  <td style={styles.cell} width="5%">
                    <p>99.4</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>0</p>
                  </td>
                  <td style={styles.cell} width="10%">
                    <p>47.8</p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>1338.13</p>
                  </td>
                  <td style={styles.cell} width="7%">
                    <p>59.91</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>0</p>
                  </td>
                  <td style={styles.cell} width="6%">
                    <p>25.45</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>0.56</p>
                  </td>
                  <td style={styles.cell} width="7%">
                    <p>5172.64</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="12%">
                    <p>Built Up</p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>0.04</p>
                  </td>
                  <td style={styles.cell} width="5%">
                    <p>1.73</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>0</p>
                  </td>
                  <td style={styles.cell} width="10%">
                    <p>0</p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>0.01</p>
                  </td>
                  <td style={styles.cell} width="7%">
                    <p>0.01</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>0</p>
                  </td>
                  <td style={styles.cell} width="6%">
                    <p>0</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>0</p>
                  </td>
                  <td style={styles.cell} width="7%">
                    <p>1.78</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="12%">
                    <p>Dry Deciduous</p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>322.24</p>
                  </td>
                  <td style={styles.cell} width="5%">
                    <p>20.5</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>460.08</p>
                  </td>
                  <td style={styles.cell} width="10%">
                    <p>13.82</p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>232.48</p>
                  </td>
                  <td style={styles.cell} width="7%">
                    <p>21.35</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>0</p>
                  </td>
                  <td style={styles.cell} width="6%">
                    <p>30.99</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>3.59</p>
                  </td>
                  <td style={styles.cell} width="7%">
                    <p>1104.80</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="12%">
                    <p>Horticulture</p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>51.29</p>
                  </td>
                  <td style={styles.cell} width="5%">
                    <p>4.83</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>0</p>
                  </td>
                  <td style={styles.cell} width="10%">
                    <p>4.32</p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>34.39</p>
                  </td>
                  <td style={styles.cell} width="7%">
                    <p>3.08</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>0</p>
                  </td>
                  <td style={styles.cell} width="6%">
                    <p>1.79</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>0.04</p>
                  </td>
                  <td style={styles.cell} width="7%">
                    <p>99.73</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="12%">
                    <p>Hillocks</p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>366.81</p>
                  </td>
                  <td style={styles.cell} width="5%">
                    <p>40.7</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>0</p>
                  </td>
                  <td style={styles.cell} width="10%">
                    <p>6.97</p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>1201.96</p>
                  </td>
                  <td style={styles.cell} width="7%">
                    <p>8.02</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>0</p>
                  </td>
                  <td style={styles.cell} width="6%">
                    <p>10.96</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>0.12</p>
                  </td>
                  <td style={styles.cell} width="7%">
                    <p>1635.55</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="12%">
                    <p>Others</p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>43.07</p>
                  </td>
                  <td style={styles.cell} width="5%">
                    <p>8.29</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>0</p>
                  </td>
                  <td style={styles.cell} width="10%">
                    <p>1.61</p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>12.89</p>
                  </td>
                  <td style={styles.cell} width="7%">
                    <p>40.45</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>0</p>
                  </td>
                  <td style={styles.cell} width="6%">
                    <p>1.34</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>0</p>
                  </td>
                  <td style={styles.cell} width="7%">
                    <p>107.63</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="12%">
                    <p>Scrubland</p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>737.68</p>
                  </td>
                  <td style={styles.cell} width="5%">
                    <p>46.4</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>0</p>
                  </td>
                  <td style={styles.cell} width="10%">
                    <p>32.57</p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>639.11</p>
                  </td>
                  <td style={styles.cell} width="7%">
                    <p>26.53</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>772.7</p>
                  </td>
                  <td style={styles.cell} width="6%">
                    <p>29.39</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>3.97</p>
                  </td>
                  <td style={styles.cell} width="7%">
                    <p>2288.35</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="12%">
                    <p>Water</p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>18.14</p>
                  </td>
                  <td style={styles.cell} width="5%">
                    <p>2.96</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>0</p>
                  </td>
                  <td style={styles.cell} width="10%">
                    <p>1.03</p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>32.24</p>
                  </td>
                  <td style={styles.cell} width="7%">
                    <p>1.09</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>0</p>
                  </td>
                  <td style={styles.cell} width="6%">
                    <p>92.78</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>0.01</p>
                  </td>
                  <td style={styles.cell} width="7%">
                    <p>148.25</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="12%">
                    <p>Forest Plantation</p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>0.08</p>
                  </td>
                  <td style={styles.cell} width="5%">
                    <p>0</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>0</p>
                  </td>
                  <td style={styles.cell} width="10%">
                    <p>0</p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>1.05</p>
                  </td>
                  <td style={styles.cell} width="7%">
                    <p>0</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>0</p>
                  </td>
                  <td style={styles.cell} width="6%">
                    <p>0</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>13</p>
                  </td>
                  <td style={styles.cell} width="7%">
                    <p>14.11</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="12%">
                    <p>
                      <strong>2019</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>5164.92</p>
                  </td>
                  <td style={styles.cell} width="5%">
                    <p>224</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>460.08</p>
                  </td>
                  <td style={styles.cell} width="10%">
                    <p>108.11</p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>3492.24</p>
                  </td>
                  <td style={styles.cell} width="7%">
                    <p>160.43</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>772.7</p>
                  </td>
                  <td style={styles.cell} width="6%">
                    <p>192.6</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>21.29</p>
                  </td>
                  <td style={styles.cell} width="7%">
                    <p>&nbsp;</p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>
              Fragmentation analyses emphasize the loss of interior forest cover
              due to anthropogenic pressures. Temporal fragmentation indicates
              the changes in urban fringe LU that significantly affect natural
              resources, especially natural habitat ecosystems, through their
              impacts on soil and water quality and climatic systems. The
              analysis reveals the decline of interior forests (10.07 to 3.68%)
              due to LU changes (Figure 5). Patch class has decreased from 4.79
              to 2.22%, transitional class decreased from 6.38 to 1.95%, edge
              class decreased from 0.88% to 0.36%, perforated class decreased
              from 9.38% to 3.51%, interior lost its area from 10.7% to 3.68%.
              The new patches are created in the interior forest areas due to
              monoculture plantations, anthropogenic induced LU features. The
              loss of interior cover is driving the wild animals to stray into
              the human habitats in search of food, fodder, and water.
            </p>
            <p>
              The spatial pattern of built-up and forest categories at
              decentralized level (9 km X 9 km grids) were assessed through the
              computation of spatial matrices, namely class area (CA), number of
              patches (NP), normalized landscape shape index (NLSI), aggregation
              index (AI). CA highlights an increase in the built-up area during
              1989 to 2019 (Figure 6). The main changes were noticed in the
              grids of &nbsp;taluks Tumkur, Tiptur and Madhugiri. Forest class
              depicts the loss of CA due to increased fragmentation. NP
              indicates the extent of fragmentation in landscape with value 0
              indicating clustering of patches into a single built-up patch,
              while higher values indicate the increase in the fragmentation. An
              increase in NP value in the Tumkur, Tiptur, and Sira taluks area
              depicts the urban sprawl or dispersed growth. With the decrease in
              the forest area,&nbsp; there has been an increase in the number of
              patches in all the forest areas especially, in the Madhugiri
              region (Figure 7). NLSI shows Tumkur and Tiptur taluks are
              undergoing intense urbanization with higher spatial complexity
              (Figure 8). NLSI for forest class shows increased spatial
              complexity due to urban sprawl and forest cover loss. NLSI values
              around the city centers increased, indicating the decline of the
              forest cover. AI value of 100 represents all the patches becoming
              clusters, while 1 shows the ungrouping of the class. An increase
              in AI value indicates the compacted growth in cities such as
              Tumkur, Madhugiri, and Tiptur (Figure 9). In contrast, peri urban
              region grids show lower values due to new clusters, especially in
              Tumkur and Tiptur outskirts. Decrease in AI value indicating
              ungrouping especially along the Madhugiri, Kunigal, and Korategere
              taluks.
            </p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/tl5.png" alt="" />{" "}
            </p>
            <p style={{ textAlign: "center" }}>
              Figure 5. Temporal change in forest structure
            </p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/tl6.png" alt="" />{" "}
            </p>
            <p style={{ textAlign: "center" }}>
              Figure 6. Class area matrix for built-up, forest classes over time
            </p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/tl7.png" alt="" />{" "}
            </p>
            <p style={{ textAlign: "center" }}>
              Figure 7. Number of patches of buil-up and forest categories
            </p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/tl8.png" alt="" />{" "}
            </p>
            <p style={{ textAlign: "center" }}>
              Figure 8. NLSI index of forest and built-up categories
            </p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/tl9.png" alt="" />{" "}
            </p>
            <p style={{ textAlign: "center" }}>
              Figure 9. AI index of forest and built-up categories
            </p>
            <p>
              The distance influence of each factor on LU is evaluated and
              weighed for projection. The consistency index of 0.04 shows
              acceptable consistency in AHP index as compared with the standard
              of 0.1. MCE helped to derive the probable LU transition maps and
              CA Markov aided in projection of likely land uses based on AHP and
              MCE inputs. The simulated 2019 map has been compared with actual
              LU of 2019 depicted good Kappa value of 0.92 with spatial
              consistency. The projected LU of 2029 portatraitslarge scale
              changes in agriculture with increase in hortulture ands built-up
              areas. The Tumkur city might be expanded further by transforming
              large tracts of agriculture patches towards the Bangalore highway.
              Intensified horticultural activity influences the transition of
              forest and agricultural land into monoculture activity, which is
              the most observed trend in the Tumkur district. Agricultural land
              decrease from 5164.92 km<sup>2</sup> (2019) to 4812.08 km
              <sup>2</sup> (2029) (Figure 10). Built-up area is likely to
              increase from 2.11% (224 km<sup>2</sup>) to 4.58% (489.11 km
              <sup>2</sup>).
            </p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/tl10.png" alt="" />{" "}
            </p>
            <p style={{ textAlign: "center" }}>
              Figure 10. Likely LU of Tumkur
            </p>
            <p>&nbsp;</p>
            <h5>
              Prioritization of Ecologically Sensitive Regions (ESRs) for
              conservation and sustainable development
            </h5>
            <p>
              ESRs at disaggregated levels in the Tumkur district was determined
              by considering land, geo-climatic, hydrological, energy, social,
              and ecological parameters. The parameters such as biomass, fauna,
              flora, stream flow, population density, livestock, % forest cover,
              % interior forest, digital elevation model, perception, % slope,
              soil type, lithology, bioenergy, wind energy, solar energy etc.,
              have aided in assessing the landscape's capability and
              significance. The weights were assigned at grid level based on
              their importance in maintaining the ecosystem and supporting
              livelihood. Forest cover and the interior forest cover variables
              implies the health of a landscape. Fragmentation of forests can
              degrade animal habitat, leading to increased instances of
              human-animal conflicts, inbreeding, and ultimately the extirpation
              of species. Madhugiri, Kunigal, and Tiptur regions have major
              forest and interior forest cover, weights were assigned based on
              the range (Figure 11).
            </p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/tl11.png" alt="" />{" "}
            </p>
            <p style={{ textAlign: "center" }}>
              Figure 11. Forest cover and interior forests of Tumkur and weight
            </p>
            <p>
              The energy prospects in the district have been assessed
              considering solar, wind, and bioenergy potential to understand the
              district's renewable energy options (Figure 12). The district has
              uniform solar insolation of &gt; 6 kilowatt/hour, which helps
              solar energy harvest at decentralized levels. The wind velocity of
              the district shows 2.5-4 meters/sec, emphasizing the capacity for
              hybrid renewable energy production by integrating solar and wind
              options to meet the regional energy. The district has uniform
              bioenergy potential due to moderate bioresources availability.
            </p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/tl12.png" alt="" />{" "}
            </p>
            <p style={{ textAlign: "center" }}>
              Figure 12. Energy prospects assessed and their weights
            </p>
            <p>
              The ecology in the district has been assessed through various
              proxy variables, as depicted in Figure 13. Forest cover change
              with the unrestrained LULC changes can diminish water flow in the
              streams and rivers, which is detrimental to the biodiversity and
              livelihoods of people in the district. Stream flow assessment
              across the grids highlights the region covered by forests has
              water availability of &nbsp;&gt; 6 months, whereas other areas
              show lower flow. Duration of stream flow is higher in the Tiptur,
              Kunigal, and Chiknayakanhalli regions. Streams in the Vedavathi
              river catchment with good forest cover house diverse native plant
              species, confirming the linkage between ecology and hydrology in
              the catchment. This provides invaluable insight to the need for
              integrated approaches in river basin management in an era
              dominated by mismanagement of river catchment with the enhanced
              deforestation process, inappropriate cropping, and poor water
              efficiency (Ramachandra et al., 2018c). Higher biomass can be seen
              in Madugiri Forest or Timmalapura Forest, whereas other regions
              show the least biomass. (Figure 13). The spatial distribution of
              flora and fauna species across the district was compiled through
              field sampling and literature review. The distribution of the
              species was assessed as per the IUCN Conservation Status, which
              depicts the concentrated grids in and around Madhugiri taluk. The
              sensitive flora includes{" "}
              <em>
                Chloroxylon swietenia, Embelia tsjeriam-cottam, Santalum album,
                Aconitum heterophyllum, Saraca asoca, Shorea roxburghii.{" "}
              </em>
              Devarayanadurga, area presents beautiful scenery of hill ranges
              with rich herbs intersected by agricultural valleys.
              Devarayanadurga region endowed with rich diversity of flora such
              as
              <em>
                {" "}
                Acacia leucophloea, Adina cardifolia, Albizia lebbek, Butea
                monosperma, Careya arborea, Chloroxylon swietenia, Diospyros
                melanoxylon, Ficus glomerata, Gardenia latifolia, Mimosa pudica,
                Odina wodier, Phyllanthus emblica, Semecarpus anacardium,
                Thevetia nerrifolia, Tinospora cordifolia, Trema orientalis,
                Vicoa indica, Vittaria elongata, Wrightia tinctoria{" "}
              </em>
              (Bhat, 2000). The fauna species such as birds (
              <em>
                Ardeotis nigriceps, Gyps bengalensis, Gyps indicus, Sarcogyps
                calvus, Aquila nipalensis, Neophron percnopterus, Sterna
                acuticauda, Sypheotides indicus, Xantholaema malabarica, Anhinga
                melanogaster, Anhinga melanogaster, Anthracoceros coronatus
              </em>
              ), mammals (
              <em>
                Antelope cervicarpa, Elephas maximus, Hyaena hyaena, Panthera
                pardus, Prionailurus rubiginosus, Melursus ursinus
              </em>
              ) are considered as sensitive fauna of the district. The district
              is home to diverse reptiles such as&nbsp; Cobra, Indian Black
              Turtle, Russell's Viper, Bamboo Pit Viper, Bengal Monitor, Common
              Krait, Wolf Snake, etc. There is also a wide variety of
              butterflies, including Crimson rose, Mottled emigrant, Lemon
              Pansy, Small orange Tip, Common Rose, Clipper, Cruiser etc.
              Mydhannahalli Black Buck Conservation Reserve, Thimlapura Wildlife
              Sanctuary, Thimlapura Conservation Reserve, and Bukkapatna
              Wildlife Sanctuary are protecting these sensitive flora and fauna.
            </p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/tl13.png" alt="" />{" "}
            </p>
            <p style={{ textAlign: "center" }}>
              Figure 13. Ecological factors and their weights
            </p>
            <p>
              Geo climatic variability has been assessed through a set of proxy
              variables, and weights were provided as depicted in Figure 14.
              Tumkur district has an annual rainfall of 743 mm with an average
              number of 46 rainy days. The taluks of Madhugiri, Koratagere,
              Sira, and Turuvekre receive good rain as compared with others. The
              district has a slope of &lt;15% except for the regions covered
              with undulating hills with clumps of tall and well-grown trees.
              Elevation maps depict two major distinct classes. The Kunigal
              taluk consists mainly of undulating hills with plains
              interspersed. Long ranges of hills running in the south-south east
              direction occupy the district's western part. The lithology of the
              district shows most of the region has gneese type followed by a
              narrow range of granitic hills grouped under closepet granites,
              which occupies the eastern part. These hills pass through the
              taluks of Madhugiri, Koratagere, Pavagada, and northern parts of
              Tumkur. The district's soil (Sandy and clayey soil) shows as they
              are moderately eroded, shallow in depth and well-drained to
              excessively drained. The weights are assigned based on water
              infiltration and soil depth characteristics.
            </p>
            <p>
              Population density (2011 census) information shows that the higher
              population density in the Tumkur and other urban areas indicates
              500-1000 persons per hectare (Figure 15). The higher weights were
              assigned for the regions of lower population density, as they
              signify less resource usage and least disturbances. The livestock
              density map shows Tiptur and Kunigal regions with the higher
              density of livestock (2.25-3), weights were assigned based on
              significance.
            </p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/tl14.png" alt="" />{" "}
            </p>
            <p style={{ textAlign: "center" }}>
              Figure 14. Geo-climatic factors assessed and their weights
            </p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/tl15.png" alt="" />{" "}
            </p>
            <p style={{ textAlign: "center" }}>
              Figure 15. Population and interior forests of Tumkur and weight
            </p>
            <p>
              Aggregate weight for each grid was computed and grouped into four
              categories as ESR 1 (with aggregated values greater than mean +
              standard deviation), ESR 2 (values between mean + standard
              deviation and mean), ESR 3 (values between mean - standard
              deviation and mean), ESR 4 (values lower than mean &ndash;
              standard deviation). Figure 16 highlights that 1377 sq. km. in the
              district falls under ESR 1 (17 grids), 3726 sq. km falls under ESR
              2 (46 grids), 5670 sq. km falls under ESR 3 (70 grids), and 1944
              sq. km falls under ESR 4 (24 grids). The ESR 1 represents a zone
              of highest conservation, and no further degradation is allowed.
              ESR-2 has the potential to become ESR 1 provided with strict
              regulations and improvement of forests and their environs by more
              protection. A small change in ESR 2 will have more adverse effects
              on ESR 1. ESR 1 and ESR 2 &ndash; signifies that they are
              susceptible zones covered under the Madhugiri, Tiptur, Kunigal
              taluks, where absolutely no development activity such as dams
              &amp; mining should not be allowed. ESR 3 is the region of
              sensitivity where agricultural and horticultural activity should
              be promoted, and large-scale industries should be restricted, but
              small-scale industries like IT sectors, and agro-based can be
              encouraged. Tumkur district covers vast extent of coconut
              plantations under ESR 3 regions. ESR 4 is the region where
              large-scale industries and highly urbanized areas are present.
              Mainly city centers of the districts come under this category.
            </p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/tl16.png" alt="" />{" "}
            </p>
            <p style={{ textAlign: "center" }}>
              Figure 16. ESRs of Tumkur district
            </p>
            <br />
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default RADPage;
